var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-wrapper',[_c('edit-office-form',{attrs:{"office-type":"member","office-id":_vm.$route.params.id,"disabled-fields":['code']},on:{"success":function($event){return _vm.$router.push({ name: 'master-mitra-usaha' })}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }